import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import type { Assessment } from "../models/assessment";

const emptyAssessment: Assessment = {
    companyName: "",
    assessmentName: "",
    assessor: "",
};

export default function AssessmentEdit() {
    const { id } = useParams<{ id: string }>();
    const [form, setForm] = useState<Assessment>(emptyAssessment);
    const navigate = useNavigate();

    useEffect(() => {
        // Later: fetch assessment by ID from your API.
        // For now, just log that we'd load it.
        console.log("Editing assessment with id:", id);
    }, [id]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ): void => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e: React.FormEvent): void => {
        e.preventDefault();

        // For now, just log it. Later this will PUT/PATCH to your backend.
        console.log("Updating assessment:", { id, ...form });

        navigate("/assessments");
    };

    return (
        <div>
            <h1>Edit Assessment</h1>

            <form
                onSubmit={handleSubmit}
                style={{ maxWidth: "500px", display: "grid", gap: "0.75rem" }}
            >
                <label>
                    Company name
                    <input
                        type="text"
                        name="companyName"
                        value={form.companyName}
                        onChange={handleChange}
                        style={{ width: "100%" }}
                        required
                    />
                </label>

                <label>
                    Assessment name
                    <input
                        type="text"
                        name="assessmentName"
                        value={form.assessmentName}
                        onChange={handleChange}
                        style={{ width: "100%" }}
                        required
                    />
                </label>

                <label>
                    Assessor
                    <input
                        type="text"
                        name="assessor"
                        value={form.assessor}
                        onChange={handleChange}
                        style={{ width: "100%" }}
                        required
                    />
                </label>

                <div style={{ marginTop: "0.5rem" }}>
                    <button type="submit" style={{ marginRight: "0.5rem" }}>
                        Save changes
                    </button>
                    <button
                        type="button"
                        onClick={() => navigate("/assessments")}
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
}
